import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProjectChatData, { fieldLabel } from './ProjectChatData';

export default function ProjectChatSavedAnswer({ answer, locked, onCheck }) {
  const { t } = useTranslation();
  const verifying = answer.purpose === 'verify';
  return <Paper variant="outlined" sx={{ p: 2 }}><Stack spacing={1.5}>
    <Typography variant="body2">{t(verifying ? 'project_chat.readable.not_verified' : 'project_chat.readable.saved_scope')}</Typography>
    {answer.freshness && (answer.freshness !== 'current' || answer.retained_result) &&
      <Typography variant="body2">{t('project_chat.readable.older_result')}</Typography>}
    {answer.results.map((result, index) => <Stack key={index} spacing={0.5}>
      {result.title && <Typography variant="subtitle2">{result.title}</Typography>}
      {result.event_id && answer.variable && <Typography variant="caption" color="text.secondary">
        {t('project_chat.readable.saved_value', { label: fieldLabel(answer.variable) })}
      </Typography>}
      {result.missing ? <Typography variant="body2">{t('project_chat.missing_value')}</Typography>
        : <ProjectChatData value={result.unavailable ? null : result.value} fields={result.display_fields} widget={Boolean(result.widget_id && !result.data_only)} />}
      {verifying && (result.widget_id || (result.event_id && answer.variable && !result.missing)) && answer.can_check_sources && onCheck && <Button variant="contained"
        disabled={locked} onClick={() => onCheck(result.widget_id
          ? t('project_chat.readable.check_request', { title: result.title || '' })
          : t('project_chat.readable.check_event_request', { variable: answer.variable, id: result.event_id }))}>
        {t(result.event_id ? 'project_chat.readable.check_event_source' : 'project_chat.readable.check_sources')}
      </Button>}
    </Stack>)}
  </Stack></Paper>;
}
